import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var d = {
  name: "ka",
  weekdays: "კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),
  weekdaysShort: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
  weekdaysMin: "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
  months: "იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),
  monthsShort: "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
  weekStart: 1,
  formats: {
    LT: "h:mm A",
    LTS: "h:mm:ss A",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY h:mm A",
    LLLL: "dddd, D MMMM YYYY h:mm A"
  },
  relativeTime: {
    future: "%s შემდეგ",
    past: "%s წინ",
    s: "წამი",
    m: "წუთი",
    mm: "%d წუთი",
    h: "საათი",
    hh: "%d საათის",
    d: "დღეს",
    dd: "%d დღის განმავლობაში",
    M: "თვის",
    MM: "%d თვის",
    y: "წელი",
    yy: "%d წლის"
  },
  ordinal: function(_) {
    return _;
  }
};
t.locale(d, null, !0);
export {
  d as default
};
